<p-select
  [options]="options"
  optionLabel="label"
  [filter]="true"
  filterBy="label"
  [showClear]="false"
  [placeholder]="placeholder"
  class="w-full"
  [disabled]="disabled"
  [ngModel]="selectedCountry"
  (ngModelChange)="setCountry($event)"
  (onFocus)="handleBlur()"
  (onBlur)="handleBlur()"
  (onHide)="handleBlur()">
  <ng-template #selectedItem let-selectedOption>
    <div class="flex items-center gap-2">
      {{ getUnicodeFlagIcon(selectedOption?.value) }}
      <div>{{ selectedOption.label }}</div>
    </div>
  </ng-template>
  <ng-template let-country #item>
    <div class="flex items-center gap-2">
      {{ getUnicodeFlagIcon(country.value) }}
      <div>{{ country.label }}</div>
    </div>
  </ng-template>
</p-select>